export const CONFIGURATION_COPY = {
  BUTTON_SAVE_CONFIGURATION: 'Save Settings',

  DRAWER_HEADER_SAVE: 'Save Configuration',

  FORM_TEXT_SAVE_CONFIGURATION: 'Create a name for this setting.',

  PLACEHOLDER_CONFIGURATION_NAME: 'Settings Name',
};
